import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash-es/noop';
import H5 from 'sushiweb/Typography/Heading/H5';
import Button from 'sushiweb/Button';
import { P } from 'sushiweb/Typography/Text';
import CheckCircleFill from 'sushiweb/Icons/all/CheckCircleFill';
import TimeFill from 'sushiweb/Icons/all/TimeFill';
import green from 'sushiweb/tokens/color/green';
import orange from 'sushiweb/tokens/color/orange';
import Modal from 'sushiweb/Modal/Modal';

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  h5 {
    font-weight: 500;
    margin-top: 2.8rem;
  }
  p {
    margin: 1rem 0 2.4rem;
    font-size: 1.6rem;
  }
`;

const VerificationModal = ({
  isVisible,
  onContinueClick,
  title,
  subtitle,
  clearSuccessModal,
  iconType,
}) => {
  const renderIcon = type => {
    if (type === 'success') {
      return <CheckCircleFill color={green.z500} size='7rem' />;
    }
    return <TimeFill color={orange.z500} size='7rem' />;
  };

  return (
    <Modal
      visible={isVisible}
      isCentered
      padding='5.4rem 6rem'
      onClose={clearSuccessModal}
    >
      <ModalContainer>
        {renderIcon(iconType)}
        <H5>{title}</H5>
        <P>{subtitle}</P>
        <Button onClick={onContinueClick}>Okay</Button>
      </ModalContainer>
    </Modal>
  );
};

VerificationModal.propTypes = {
  isVisible: PropTypes.bool,
  onContinueClick: PropTypes.func,
  clearSuccessModal: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  iconType: PropTypes.string,
};

VerificationModal.defaultProps = {
  isVisible: false,
  clearSuccessModal: _noop,
  onContinueClick: _noop,
  title: '',
  subtitle: '',
  iconType: 'checkCircleFill',
};

export default VerificationModal;
